// Shared country dial-code data and phone helpers.
//
// The backend stores `phone_no` as a single E.164 string with the leading `+`
// (e.g. "+919072824973") and looks users up by exact match, so anything we send
// has to carry the country code.

export const countryCodeMap = {
  AF: { code: '+93', name: 'Afghanistan' },
  AL: { code: '+355', name: 'Albania' },
  DZ: { code: '+213', name: 'Algeria' },
  AS: { code: '+1684', name: 'American Samoa' },
  AD: { code: '+376', name: 'Andorra' },
  AO: { code: '+244', name: 'Angola' },
  AI: { code: '+1264', name: 'Anguilla' },
  AG: { code: '+1268', name: 'Antigua and Barbuda' },
  AR: { code: '+54', name: 'Argentina' },
  AM: { code: '+374', name: 'Armenia' },
  AW: { code: '+297', name: 'Aruba' },
  AU: { code: '+61', name: 'Australia' },
  AT: { code: '+43', name: 'Austria' },
  AZ: { code: '+994', name: 'Azerbaijan' },
  BS: { code: '+1242', name: 'Bahamas' },
  BH: { code: '+973', name: 'Bahrain' },
  BD: { code: '+880', name: 'Bangladesh' },
  BB: { code: '+1246', name: 'Barbados' },
  BY: { code: '+375', name: 'Belarus' },
  BE: { code: '+32', name: 'Belgium' },
  BZ: { code: '+501', name: 'Belize' },
  BJ: { code: '+229', name: 'Benin' },
  BM: { code: '+1441', name: 'Bermuda' },
  BT: { code: '+975', name: 'Bhutan' },
  BO: { code: '+591', name: 'Bolivia' },
  BA: { code: '+387', name: 'Bosnia and Herzegovina' },
  BW: { code: '+267', name: 'Botswana' },
  BR: { code: '+55', name: 'Brazil' },
  BN: { code: '+673', name: 'Brunei' },
  BG: { code: '+359', name: 'Bulgaria' },
  BF: { code: '+226', name: 'Burkina Faso' },
  BI: { code: '+257', name: 'Burundi' },
  KH: { code: '+855', name: 'Cambodia' },
  CM: { code: '+237', name: 'Cameroon' },
  CA: { code: '+1', name: 'Canada' },
  CV: { code: '+238', name: 'Cape Verde' },
  KY: { code: '+1345', name: 'Cayman Islands' },
  CF: { code: '+236', name: 'Central African Republic' },
  TD: { code: '+235', name: 'Chad' },
  CL: { code: '+56', name: 'Chile' },
  CN: { code: '+86', name: 'China' },
  CO: { code: '+57', name: 'Colombia' },
  KM: { code: '+269', name: 'Comoros' },
  CG: { code: '+242', name: 'Congo' },
  CD: { code: '+243', name: 'Congo, Democratic Republic' },
  CK: { code: '+682', name: 'Cook Islands' },
  CR: { code: '+506', name: 'Costa Rica' },
  CI: { code: '+225', name: "Cote d'Ivoire" },
  HR: { code: '+385', name: 'Croatia' },
  CU: { code: '+53', name: 'Cuba' },
  CY: { code: '+357', name: 'Cyprus' },
  CZ: { code: '+420', name: 'Czech Republic' },
  DK: { code: '+45', name: 'Denmark' },
  DJ: { code: '+253', name: 'Djibouti' },
  DM: { code: '+1767', name: 'Dominica' },
  DO: { code: '+1', name: 'Dominican Republic' },
  EC: { code: '+593', name: 'Ecuador' },
  EG: { code: '+20', name: 'Egypt' },
  SV: { code: '+503', name: 'El Salvador' },
  GQ: { code: '+240', name: 'Equatorial Guinea' },
  ER: { code: '+291', name: 'Eritrea' },
  EE: { code: '+372', name: 'Estonia' },
  ET: { code: '+251', name: 'Ethiopia' },
  FK: { code: '+500', name: 'Falkland Islands' },
  FO: { code: '+298', name: 'Faroe Islands' },
  FJ: { code: '+679', name: 'Fiji' },
  FI: { code: '+358', name: 'Finland' },
  FR: { code: '+33', name: 'France' },
  GF: { code: '+594', name: 'French Guiana' },
  PF: { code: '+689', name: 'French Polynesia' },
  GA: { code: '+241', name: 'Gabon' },
  GM: { code: '+220', name: 'Gambia' },
  GE: { code: '+995', name: 'Georgia' },
  DE: { code: '+49', name: 'Germany' },
  GH: { code: '+233', name: 'Ghana' },
  GI: { code: '+350', name: 'Gibraltar' },
  GR: { code: '+30', name: 'Greece' },
  GL: { code: '+299', name: 'Greenland' },
  GD: { code: '+1473', name: 'Grenada' },
  GP: { code: '+590', name: 'Guadeloupe' },
  GU: { code: '+1671', name: 'Guam' },
  GT: { code: '+502', name: 'Guatemala' },
  GN: { code: '+224', name: 'Guinea' },
  GW: { code: '+245', name: 'Guinea-Bissau' },
  GY: { code: '+592', name: 'Guyana' },
  HT: { code: '+509', name: 'Haiti' },
  HN: { code: '+504', name: 'Honduras' },
  HK: { code: '+852', name: 'Hong Kong' },
  HU: { code: '+36', name: 'Hungary' },
  IS: { code: '+354', name: 'Iceland' },
  IN: { code: '+91', name: 'India' },
  ID: { code: '+62', name: 'Indonesia' },
  IR: { code: '+98', name: 'Iran' },
  IQ: { code: '+964', name: 'Iraq' },
  IE: { code: '+353', name: 'Ireland' },
  IL: { code: '+972', name: 'Israel' },
  IT: { code: '+39', name: 'Italy' },
  JM: { code: '+1876', name: 'Jamaica' },
  JP: { code: '+81', name: 'Japan' },
  JO: { code: '+962', name: 'Jordan' },
  KZ: { code: '+7', name: 'Kazakhstan' },
  KE: { code: '+254', name: 'Kenya' },
  KI: { code: '+686', name: 'Kiribati' },
  KW: { code: '+965', name: 'Kuwait' },
  KG: { code: '+996', name: 'Kyrgyzstan' },
  LA: { code: '+856', name: 'Laos' },
  LV: { code: '+371', name: 'Latvia' },
  LB: { code: '+961', name: 'Lebanon' },
  LS: { code: '+266', name: 'Lesotho' },
  LR: { code: '+231', name: 'Liberia' },
  LY: { code: '+218', name: 'Libya' },
  LI: { code: '+423', name: 'Liechtenstein' },
  LT: { code: '+370', name: 'Lithuania' },
  LU: { code: '+352', name: 'Luxembourg' },
  MO: { code: '+853', name: 'Macau' },
  MK: { code: '+389', name: 'Macedonia' },
  MG: { code: '+261', name: 'Madagascar' },
  MW: { code: '+265', name: 'Malawi' },
  MY: { code: '+60', name: 'Malaysia' },
  MV: { code: '+960', name: 'Maldives' },
  ML: { code: '+223', name: 'Mali' },
  MT: { code: '+356', name: 'Malta' },
  MH: { code: '+692', name: 'Marshall Islands' },
  MQ: { code: '+596', name: 'Martinique' },
  MR: { code: '+222', name: 'Mauritania' },
  MU: { code: '+230', name: 'Mauritius' },
  YT: { code: '+262', name: 'Mayotte' },
  MX: { code: '+52', name: 'Mexico' },
  FM: { code: '+691', name: 'Micronesia' },
  MD: { code: '+373', name: 'Moldova' },
  MC: { code: '+377', name: 'Monaco' },
  MN: { code: '+976', name: 'Mongolia' },
  ME: { code: '+382', name: 'Montenegro' },
  MS: { code: '+1664', name: 'Montserrat' },
  MA: { code: '+212', name: 'Morocco' },
  MZ: { code: '+258', name: 'Mozambique' },
  MM: { code: '+95', name: 'Myanmar' },
  NA: { code: '+264', name: 'Namibia' },
  NR: { code: '+674', name: 'Nauru' },
  NP: { code: '+977', name: 'Nepal' },
  NL: { code: '+31', name: 'Netherlands' },
  NC: { code: '+687', name: 'New Caledonia' },
  NZ: { code: '+64', name: 'New Zealand' },
  NI: { code: '+505', name: 'Nicaragua' },
  NE: { code: '+227', name: 'Niger' },
  NG: { code: '+234', name: 'Nigeria' },
  NU: { code: '+683', name: 'Niue' },
  NF: { code: '+672', name: 'Norfolk Island' },
  KP: { code: '+850', name: 'North Korea' },
  MP: { code: '+1670', name: 'Northern Mariana Islands' },
  NO: { code: '+47', name: 'Norway' },
  OM: { code: '+968', name: 'Oman' },
  PK: { code: '+92', name: 'Pakistan' },
  PW: { code: '+680', name: 'Palau' },
  PS: { code: '+970', name: 'Palestine' },
  PA: { code: '+507', name: 'Panama' },
  PG: { code: '+675', name: 'Papua New Guinea' },
  PY: { code: '+595', name: 'Paraguay' },
  PE: { code: '+51', name: 'Peru' },
  PH: { code: '+63', name: 'Philippines' },
  PL: { code: '+48', name: 'Poland' },
  PT: { code: '+351', name: 'Portugal' },
  PR: { code: '+1', name: 'Puerto Rico' },
  QA: { code: '+974', name: 'Qatar' },
  RE: { code: '+262', name: 'Reunion' },
  RO: { code: '+40', name: 'Romania' },
  RU: { code: '+7', name: 'Russia' },
  RW: { code: '+250', name: 'Rwanda' },
  KN: { code: '+1869', name: 'Saint Kitts and Nevis' },
  LC: { code: '+1758', name: 'Saint Lucia' },
  VC: { code: '+1784', name: 'Saint Vincent and the Grenadines' },
  WS: { code: '+685', name: 'Samoa' },
  SM: { code: '+378', name: 'San Marino' },
  ST: { code: '+239', name: 'Sao Tome and Principe' },
  SA: { code: '+966', name: 'Saudi Arabia' },
  SN: { code: '+221', name: 'Senegal' },
  RS: { code: '+381', name: 'Serbia' },
  SC: { code: '+248', name: 'Seychelles' },
  SL: { code: '+232', name: 'Sierra Leone' },
  SG: { code: '+65', name: 'Singapore' },
  SK: { code: '+421', name: 'Slovakia' },
  SI: { code: '+386', name: 'Slovenia' },
  SB: { code: '+677', name: 'Solomon Islands' },
  SO: { code: '+252', name: 'Somalia' },
  ZA: { code: '+27', name: 'South Africa' },
  KR: { code: '+82', name: 'South Korea' },
  SS: { code: '+211', name: 'South Sudan' },
  ES: { code: '+34', name: 'Spain' },
  LK: { code: '+94', name: 'Sri Lanka' },
  SD: { code: '+249', name: 'Sudan' },
  SR: { code: '+597', name: 'Suriname' },
  SZ: { code: '+268', name: 'Swaziland' },
  SE: { code: '+46', name: 'Sweden' },
  CH: { code: '+41', name: 'Switzerland' },
  SY: { code: '+963', name: 'Syria' },
  TW: { code: '+886', name: 'Taiwan' },
  TJ: { code: '+992', name: 'Tajikistan' },
  TZ: { code: '+255', name: 'Tanzania' },
  TH: { code: '+66', name: 'Thailand' },
  TL: { code: '+670', name: 'Timor-Leste' },
  TG: { code: '+228', name: 'Togo' },
  TK: { code: '+690', name: 'Tokelau' },
  TO: { code: '+676', name: 'Tonga' },
  TT: { code: '+1868', name: 'Trinidad and Tobago' },
  TN: { code: '+216', name: 'Tunisia' },
  TR: { code: '+90', name: 'Turkey' },
  TM: { code: '+993', name: 'Turkmenistan' },
  TC: { code: '+1649', name: 'Turks and Caicos Islands' },
  TV: { code: '+688', name: 'Tuvalu' },
  UG: { code: '+256', name: 'Uganda' },
  UA: { code: '+380', name: 'Ukraine' },
  AE: { code: '+971', name: 'United Arab Emirates' },
  GB: { code: '+44', name: 'United Kingdom' },
  US: { code: '+1', name: 'United States' },
  UY: { code: '+598', name: 'Uruguay' },
  UZ: { code: '+998', name: 'Uzbekistan' },
  VU: { code: '+678', name: 'Vanuatu' },
  VA: { code: '+39', name: 'Vatican City' },
  VE: { code: '+58', name: 'Venezuela' },
  VN: { code: '+84', name: 'Vietnam' },
  VG: { code: '+1284', name: 'Virgin Islands, British' },
  VI: { code: '+1340', name: 'Virgin Islands, U.S.' },
  WF: { code: '+681', name: 'Wallis and Futuna' },
  YE: { code: '+967', name: 'Yemen' },
  ZM: { code: '+260', name: 'Zambia' },
  ZW: { code: '+263', name: 'Zimbabwe' },
};

// Qatar: the platform's home market, so it is the sensible default.
export const DEFAULT_DIAL_CODE = '+974';

// All countries with dial codes, sorted alphabetically by country name.
export const getAllCountriesWithDialCodes = () =>
  Object.entries(countryCodeMap)
    .map(([countryCode, data]) => ({
      countryCode,
      dialCode: data.code,
      name: data.name,
      displayText: `${data.code} (${data.name})`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

// Split a stored "+919072824973" into { dialCode: '+91', nationalNumber: '9072824973' }.
export const parsePhoneNumber = fullPhoneNumber => {
  if (!fullPhoneNumber || !fullPhoneNumber.startsWith('+')) {
    return { dialCode: DEFAULT_DIAL_CODE, nationalNumber: fullPhoneNumber || '' };
  }

  // Longest dial code first so "+1264" wins over "+1".
  const sortedCodes = Object.values(countryCodeMap)
    .map(country => country.code)
    .sort((a, b) => b.length - a.length);

  for (const code of sortedCodes) {
    if (fullPhoneNumber.startsWith(code)) {
      return { dialCode: code, nationalNumber: fullPhoneNumber.substring(code.length) };
    }
  }

  return { dialCode: DEFAULT_DIAL_CODE, nationalNumber: fullPhoneNumber.substring(1) };
};

// Build the E.164 value the backend stores. A value the user already typed with
// a "+" is trusted as-is so we never double-prefix it.
export const toE164 = (value, dialCode = DEFAULT_DIAL_CODE) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  if (raw.startsWith('+')) {
    return `+${raw.replace(/[^0-9]/g, '')}`;
  }
  const digits = raw.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return `${dialCode}${digits}`;
};

// True when the text is being used as a phone number rather than an email.
export const looksLikePhoneInput = value => {
  const raw = String(value ?? '').trim();
  if (!raw) return false;
  return /^\+?[0-9\s()-]+$/.test(raw);
};
